import styled from 'styled-components';

import { spaceL, spaceXL, spaceXXL, xdlColorText } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 100%;
  .industry {
    width: 100%;
    display: block;
    max-width: 50%;
    padding: ${spaceL};
    color: ${xdlColorText};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
    @media (min-width: 740px) {
      width: 100%;
      max-width: calc(100% / 3);
    }
  }
`;

export const IndustriTitle = styled(Headline)<$TSFixMe>`
  margin-top: ${spaceXL};
  margin-bottom: ${spaceXXL};
`;
